import { render, staticRenderFns } from "./usersManual.vue?vue&type=template&id=31c0b72c"
import script from "./usersManual.vue?vue&type=script&lang=js"
export * from "./usersManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports